// src/main.jsx

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import { UserProvider } from './contexts/UserContext';
import App from './App.jsx';
import './index.css';
import { getEnvironmentConfig } from './config/platforms';

// Set document title and meta tags based on platform
const config = getEnvironmentConfig();
const client_id = import.meta.env.VITE_AUTH0_CLIENT_ID || "PumUMbADVroGUMUPhgoxnRYZHwH7syNd";
document.title = config.appName;
document.querySelector('meta[name="description"]')?.setAttribute('content', config.platform.description);
document.querySelector('meta[name="theme-color"]')?.setAttribute('content', config.themeColor);
document.querySelector('meta[name="apple-mobile-web-app-title"]')?.setAttribute('content', config.appShortName);


createRoot(document.getElementById('root')).render(
  <Auth0Provider
    domain="rehabiliationhealth.us.auth0.com"
    clientId={client_id}
    authorizationParams={{
      redirect_uri: window.location.origin,
      scope: "openid profile email offline_access"
    }}
    cacheLocation="localstorage"
    useRefreshTokens={true}
    useRefreshTokensFallback={true}
    onRedirectCallback={(appState) => {
      // A fresh interactive login proves presence — stamp activity so the
      // 60-min inactivity check doesn't logout the brand-new session based
      // on a stale timestamp from the previous visit
      localStorage.setItem('erx_last_activity', Date.now().toString());
      // Replicate the SDK default: strip code/state from the URL
      window.history.replaceState({}, document.title, appState?.returnTo || window.location.pathname);
    }}
  >
    <UserProvider>
      <App />
    </UserProvider>
  </Auth0Provider>
);